import React, { useEffect, useState } from 'react';
import { MetaTags } from "react-meta-tags";
import { Col, Container, Row, Table } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getAnswerAgentProfile, getQuoteFunnelQuestions, updateQuoteFunnelQuestionsWithAnswers } from 'store/quote_funnels/answers/actions';
import LoadingSpinner from 'components/Common/LoadingSpinner';
import Header from './QuoteFunnelAnswerLayout/Header';
import Footer from './QuoteFunnelAnswerLayout/Footer';
import { Collapse } from 'reactstrap';
import NumberFormat from 'react-number-format';
import { useParams, Link, useHistory } from 'react-router-dom';
import useQuoteFunnelOrderedQuestions from 'hooks/useQuoteFunnelOrderedQuestions';
import { SUPPORTED_TARGET_CASE, capitalizeFirstLetter, changeCase, getFilteredQuestions, getOptionFromValueForSelectBox } from 'helpers/sf_utils';
import { phoneNumberFormatter } from 'pages/Admin/Users/UserComponents/UserList/Formatters';
import { quoteFunnelSplashFieldsLabelMapping, validate_email_review, validate_phone_request } from 'helpers/quote_funnel_helper';
import useQuery from 'hooks/useQuery';
import { QUESTION_FIELD_NAMES, REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants';
import useClearableTimeout from 'hooks/useClearableTimeout';
import useFeatureFlags from 'hooks/useFeatureFlags';
import one_logo from "assets/images/1-icon.png"
import { concentFormSubmit } from 'store/consent-confirmation/action';

const ReviewQuoteFunnelAnswer = () => {
    const MAX_RETRY_COUNT = 6
    const RETRY_TIMEOUT = 1000
    const DEFAULT_RETRY_TIMEOUT = 500

    const dispatch = useDispatch();
    const history = useHistory();
    const { campaign_id, session_id } = useParams();
    const [yourPhoneNumber, setYourPhoneNumber] = useState('')
    const [phoneNumQuestion, setPhoneNumQuestion] = useState()
    const [setFormSubmitTimeout] = useClearableTimeout();

    const [isPhoneValid, setIsPhoneValid] = useState(true)
    const initial_params = {
        session_id: session_id,
        campaign_id: campaign_id
    }

    const [quoteFormSubmitLoading, setQuoteFormSubmitLoading] = useState(null);
    const [quoteFormSubmit, setQuoteFormSubmit] = useState([]);
    const [isProfileReviewOpen, setIsProfileReviewOpen] = useState(false);
    const [quote_funnel_questions_ordered, quote_funnel_page_groups_ordered] = useQuoteFunnelOrderedQuestions();
    const [isFeatureFlagActive] = useFeatureFlags();
    const new_consent_ui_ff = isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ENABLE_CUSTOM_CONSENT_UI)
    const submit_after_retry_ff = isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_RETRY_ON_QUOTE_FORM_SUBMIT)

    const handleProfileReviewOpen = () => {
        setIsProfileReviewOpen(!isProfileReviewOpen);
    };

    const onClickEditQuoteFunnel = (e, quote_funnel) => {
        e.preventDefault();
        const { page_index, page_group_index } = quote_funnel;
        history.push(`/forms/session/${session_id}?page_group_current_index=${page_group_index || ''}&page_current_index=${page_index || ''}&review=1`)
    };

    const quote_funnel_review_filter = (item) => {
        if (item?.depends_on) {
            return getFilteredQuestions({ questions: [{ ...item }] }, quote_funnel_questions_ordered)?.length
        } else if (item.repeatable_type === 'add_another_instance_prompt') {
            return false;
        }
        return true
    }

    const getValueForReview = (question) => {
        switch (question?.field_name) {
            case QUESTION_FIELD_NAMES.PHONE_NUMBER:
                return phoneNumberFormatter(question?.value.toString())
            case QUESTION_FIELD_NAMES.FIRST_NAME:
            case QUESTION_FIELD_NAMES.LAST_NAME:
                return capitalizeFirstLetter(question?.value)
            case QUESTION_FIELD_NAMES.COVERAGE_AMOUNT:
            case QUESTION_FIELD_NAMES.SQUARE_FOOTAGE:
                return getOptionFromValueForSelectBox(JSON.parse(question?.drop_down_values), question?.value)?.label
            default:
                return question?.value
        }
    }

    const data = quote_funnel_questions_ordered.filter(quote_funnel_review_filter).map((q) => {
        const fieldMapping = quoteFunnelSplashFieldsLabelMapping.find((item) => q.field_name in item);
        return {
            label: fieldMapping ? fieldMapping[q.field_name] : changeCase(q.field_name, SUPPORTED_TARGET_CASE.CAPITALIZE_EVERY_WORD),
            value: !q.value ? '--' : getValueForReview(q),
            page_group_id: q.page_group_id,
            page_id: q.page_id,
            field_name: q.field_name,
            page_index: q.page_index,
            page_group_index: q.page_group_index,
        };
    });
    const query = useQuery();
    const preview = parseInt(query.get('preview') || 0);
    const review = parseInt(query.get('review') || 0);

    useEffect(() => {
        const phoneNumberQuestion = quote_funnel_questions_ordered.find(item => item.field_name === QUESTION_FIELD_NAMES.PHONE_NUMBER)
        setPhoneNumQuestion(phoneNumberQuestion)
        const phoneNumberField = phoneNumberQuestion?.value || null
        if (phoneNumberField) {
            setYourPhoneNumber(phoneNumberField || '')
        }
    }, [quote_funnel_questions_ordered]);

    useEffect(async () => {
        if (phoneNumQuestion) {
            let isPhoneNumValid = true
            if (phoneNumQuestion?.required && !yourPhoneNumber) {
                isPhoneNumValid = false
            } else if (yourPhoneNumber) {
                isPhoneNumValid = await validate_phone_request(phoneNumQuestion, yourPhoneNumber)
            }
            setIsPhoneValid(isPhoneNumValid)
        }
    }, [yourPhoneNumber]);

    const {
        answer_agent_profile,
        answer_agent_profile_loading,
        quote_funnel_questions,
        quote_funnel_questions_loading,
        quote_form_visit
    } = useSelector((state) => ({
        answer_agent_profile: state.QuoteFunnelAnswersAgentProfileReducer.answer_agent_profile,
        answer_agent_profile: state.QuoteFunnelAnswersAgentProfileReducer.answer_agent_profile,
        quote_funnel_questions: state.QuoteFunnelAnswersAgentProfileReducer.quote_funnel_questions,
        quote_funnel_questions_loading: state.QuoteFunnelAnswersAgentProfileReducer.quote_funnel_questions_loading,
        quote_form_visit: state.QuoteFunnelAnswersAgentProfileReducer.quote_form_visit
    }));

    useEffect(() => {
        dispatch(getAnswerAgentProfile(initial_params));
        const data = {
            ...initial_params,
        }
        if (quote_form_visit) {
            data.quote_form_visit_id = quote_form_visit.id
        } else {
            if (!preview) {
                data.create_visit = 1
            }
        }
        dispatch(getQuoteFunnelQuestions(data));
    }, [session_id]);

    let first_name = quote_funnel_questions_ordered.find(item => item.field_name === 'first_name')?.value;
    // Since questions are ordered, pick the first one which matches (if exact match fails)
    if (!first_name) {
        first_name = quote_funnel_questions_ordered.find(item => item.field_name.includes('first_name'))?.value;
    }

    if (quote_funnel_questions_loading) {
        return <LoadingSpinner />
    }
    let page_title = !answer_agent_profile?.name ? '' : (answer_agent_profile?.name + " | " + quote_funnel_questions?.name)

    const onClickSubmitQuoteFunnel = async (trusted_form_token_value, new_leadid_token_value, consent_certificate_id) => {
        const [isEmailValid, email_page_index, email_page_group_index] = await validate_email_review(quote_funnel_questions_ordered)
        if (!isEmailValid) {
            history.push(`/forms/session/${session_id}?page_group_current_index=${email_page_group_index || ''}&page_current_index=${email_page_index || ''}&review=1`)
            return
        }
        const leadid_token = document.getElementById('leadid_token');
        const disclosureDiv = document.getElementById('leadid_tcpa_disclosure');
        // Get all <p> elements within the div

        const tcpa = {}

        if (disclosureDiv) {
            const paragraphs = disclosureDiv.getElementsByTagName('p');
            // Iterate through the <p> elements and extract their text content
            const textArray = [];
            for (let i = 0; i < paragraphs.length; i++) {
                textArray.push(paragraphs[i].textContent);
            }
            // Join the extracted text content (if needed)
            tcpa.text = textArray.join('\n');
        }

        let newState = {
            ...quote_funnel_questions,
            jornaya_lead_id: leadid_token?.value,
            tcpa: tcpa,
            page_groups: quote_funnel_questions?.page_groups?.map((pg) => ({
                ...pg,
                pages: pg?.pages?.map((p) => ({
                    ...p,
                    question_groups: p?.question_groups?.map((qg) => ({
                        ...qg,
                        questions: qg?.questions?.map((q) => {
                            if (q?.field_name === QUESTION_FIELD_NAMES.PHONE_NUMBER) {
                                return {
                                    ...q,
                                    value: yourPhoneNumber,
                                    prefilled: q?.prefilled || !!q?.value
                                }
                            }
                            return {
                                ...q,
                                prefilled: q?.prefilled || !!q?.value
                            }
                        })
                    }))
                }))
            }))
        }

        const payload = {
            section_name: 'submit',
            session_id: session_id,
            quote_form_visit_id: quote_form_visit?.id,
            data: newState,
            trusted_form_token: trusted_form_token_value || "",
            jornaya_lead_id: new_leadid_token_value || ""
        }
        if (new_consent_ui_ff) {
            payload.consent_certificate_id = consent_certificate_id || null
        }
        const additional_info = {
            review: 2,
            campaign_id: campaign_id,
            session_id: session_id
        }
        dispatch(concentFormSubmit({certificate_id: consent_certificate_id}));
        dispatch(updateQuoteFunnelQuestionsWithAnswers(payload, additional_info, history));
    }

    const submitFormIfReady = () => {
        const new_trusted_form_token = document.getElementsByName('xxTrustedFormToken') || "";
        const new_leadid_token = document.getElementById('leadid_token') || "";
        const trusted_form_token = new_trusted_form_token[0]?.value || "";
        const trusted_form_token_value = trusted_form_token?.split("/")?.pop() || '';
        const new_leadid_token_value = new_leadid_token?.value;
        const newConsentCertificateId = document.querySelector('input[name="consent-confirmation-certificate-id"]')?.value
        const isConsentCertificateIdPresent = new_consent_ui_ff ? !!newConsentCertificateId : true;

        if (submit_after_retry_ff) {
            let retryCount = 0;
            const retrySubmit = () => {
                if (retryCount < MAX_RETRY_COUNT) {
                    if (!!trusted_form_token_value && !!new_leadid_token_value && isConsentCertificateIdPresent) {
                        setQuoteFormSubmitLoading(false);
                        onClickSubmitQuoteFunnel(trusted_form_token_value, new_leadid_token_value, newConsentCertificateId);
                    } else {
                        setQuoteFormSubmitLoading(true);
                        setFormSubmitTimeout(retrySubmit, RETRY_TIMEOUT);
                        retryCount++;
                    }
                } else {
                    setQuoteFormSubmitLoading(false);
                    onClickSubmitQuoteFunnel(trusted_form_token_value, new_leadid_token_value, newConsentCertificateId);
                }
            };
            retrySubmit();
        } else {
            if (!!trusted_form_token_value && !!new_leadid_token_value && isConsentCertificateIdPresent) {
                setQuoteFormSubmitLoading(false);
                onClickSubmitQuoteFunnel(trusted_form_token_value, new_leadid_token_value, newConsentCertificateId);
            } else {
                setQuoteFormSubmitLoading(true);
                setFormSubmitTimeout(submitFormIfReady, DEFAULT_RETRY_TIMEOUT);
            }
        }
    }

    const onClickSubmit = async (e) => {
        e.preventDefault();

        dispatch(getQuoteFunnelQuestions({
            ...initial_params,
            update_visit: 1,
            submit_clicked: true,
            quote_form_visit_id: quote_form_visit?.id
        }))

        const new_trusted_form_token = document.getElementsByName('xxTrustedFormToken') || "";
        const new_leadid_token = document.getElementById('leadid_token') || "";
        const trusted_form_token = new_trusted_form_token[0]?.value || "";
        const trusted_form_token_value = trusted_form_token?.split("/")?.pop() || '';
        const new_leadid_token_value = new_leadid_token?.value;
        const newConsentCertificateId = document.querySelector('input[name="consent-confirmation-certificate-id"]')?.value
        const isConsentCertificateIdPresent = new_consent_ui_ff ? !!newConsentCertificateId : true;

        if (!!trusted_form_token_value && !!new_leadid_token_value && isConsentCertificateIdPresent) {
            onClickSubmitQuoteFunnel(trusted_form_token_value, new_leadid_token_value, newConsentCertificateId);
            setQuoteFormSubmitLoading(false);
        } else {
            setQuoteFormSubmitLoading(true);
            setQuoteFormSubmit([...quoteFormSubmit, onClickSubmitQuoteFunnel]);
            setFormSubmitTimeout(submitFormIfReady, DEFAULT_RETRY_TIMEOUT);
        }
       
    }

    return (
        <React.Fragment>
            <MetaTags>
                <title>{page_title}</title>
            </MetaTags>
            <div className={`page-content ${isProfileReviewOpen ? 'quote-funnel-div' : "quote-funnel-div-wrapper"}`} style={{ padding: '0px' }}>
                <Header answer_agent_profile={answer_agent_profile} stepper={false}
                    lead_type_id={quote_funnel_questions?.lead_type_id || null}
                    tracking_number={quote_funnel_questions?.tracking_number}
                    user_name={first_name}
                    phone_number_text={preview === 1 ? answer_agent_profile?.phone_num : null}
                />
                <input 
                    type="checkbox"
                    id="companies_1"
                    value="true"
                    checked="true"
                    className="consent-confirmation-brand"
                    data-brand-name={answer_agent_profile?.name}
                    style={{ position: 'absolute', visibility: 'hidden', height: 0, width: 0, margin: 0, padding: 0 }}
                />
                <Container>
                    <Row className='text-center m-1 mb-3'>
                        <Col md="12">
                            <form>
                                <h3 className='mb-3 text-black'>Your Phone Number</h3>
                                <div className='text-center quote-funnel-review-page-phone-number'>
                                    <NumberFormat
                                        className="form-control mx-auto text-center"
                                        style={{ height: '34px', fontWeight: '600', border: 'none', fontSize: '20px', width: '100%' }}
                                        format="(###) ###-####"
                                        type="text"
                                        placeholder='(xxx) xxx-xxxx'
                                        value={yourPhoneNumber}
                                        onChange={(e) => {
                                            e.persist();
                                            const value = parseInt(e.target?.value?.replace(/[^0-9]/g, ""))
                                            setYourPhoneNumber(value);
                                        }}
                                    />
                                </div>
                            </form>
                        </Col>
                        {
                            (!!yourPhoneNumber && !isPhoneValid) && (
                                <Row className='text-center mt-2'>
                                    <Col className='quote-funnel-invalid-values-review'>
                                        Please enter a valid phone number
                                    </Col>
                                </Row>
                            )
                        }
                    </Row>
                    <Row className='text-center mb-2'>
                        <Col md="12">
                            <button className="btn btn-lg quote-funnel-answer-btn quote-funnel-continue-and-quote-btn quote-funnel-continue-btn-with-one-icon consent-confirmation-form-submit"
                                type='submit'
                                onClick={onClickSubmit}
                                disabled={quote_funnel_questions_loading || !isPhoneValid || quoteFormSubmitLoading}
                            >
                                <div className="d-flex justify-content-center align-items-center">
                                    {
                                        quoteFormSubmitLoading ? (
                                            'Please wait...'
                                        ) : (
                                            <span>
                                                Continue &amp; Get Quote <i className="bx fw-bold bx-right-arrow-alt"></i>
                                            </span>
                                        )
                                    }
                                </div>
                            </button>
                            <img src={one_logo} alt="One Logo" className='quote-funnel-review-page-one-logo mb-5' />
                        </Col>
                    </Row>
                    <Row className='text-center'>
                        <Col md="12" className='text-center d-flex align-item-center justify-content-around'>
                            <button
                                className="btn fw-bold review-your-profile-btn"
                                onClick={handleProfileReviewOpen}
                            >
                                Review Your Profile
                                <span className={`m-2 fa fa-angle-${isProfileReviewOpen ? "up" : "down"}`}></span>
                            </button>
                        </Col>
                    </Row>

                    <div className='h-100'>
                        <Collapse isOpen={isProfileReviewOpen}>
                            <div className="profile-review-content text-center review-page-preview-modal">
                                <Table style={{ border: '1px solid #cccccc', borderTop: 'none' }}>
                                    <tbody>
                                        {(data || []).map((item) => (
                                            <tr key={item.label} style={{ border: "none" }}>
                                                <td className='text-left fs-16' style={{ border: "none", maxWidth: '110px', overflowWrap: 'break-word' }}>{item.label}</td>
                                                <td className='text-left fs-16 ' style={{ border: "none" }}><Link onClick={(e) => onClickEditQuoteFunnel(e, item)} className='text-sfblue'>Edit</Link></td>
                                                <td className='text-left fw-700 fs-16 font-weight-semibold' style={{ border: "none", maxWidth: '110px', overflowWrap: 'break-word' }}>{item.value}</td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Collapse>
                    </div>
                </Container>
                <Footer 
                    answer_agent_profile={answer_agent_profile} 
                    disclaimer={true} tracking_number={quote_funnel_questions?.tracking_number} 
                    stepper={false} phone_number_text={preview === 1 ? answer_agent_profile?.phone_num : null} 
                    tcpa_disclaimer_text={answer_agent_profile?.tcpa_content}
                />
            </div>
        </React.Fragment>

    );
};

export default ReviewQuoteFunnelAnswer;
